module.exports = __webpack_public_path__ + "assets/img/13.0eba9fa0.png";